






























































































































































































































































import { State, Action, Getter, Mutation } from "vuex-class";
import { Component, Vue, Prop } from "vue-property-decorator";
import { pageDataType } from "../types";
import { HOST, API_URL } from "../global";
import { pageData } from "@/store/pageData";
import { FETCH_PAGE_BY_ID } from "../store/actions.names";
import { ValidationObserver, ValidationProvider } from "vee-validate";
import axios from "axios";
import {
  TimelineMax,
  Expo,
  TweenLite,
  TweenMax,
  Power2,
  Power3,
  Power1,
} from "gsap";

const DEFAULT_JOBAPP_FORM = {
  name: "",
  email: "",
  phone_number: "",
  media_url: "",
  education: "",
  experience: "",
  job: null,
};
@Component({
  name: "JobApplicaionPage",
  components: {
    ValidationObserver,
    ValidationProvider,
  },
})
export default class JobApplicaionPage extends Vue {
  @Prop() pageData!: pageDataType;
  public HOST: string = HOST;
  public jobappform: any = JSON.parse(JSON.stringify(DEFAULT_JOBAPP_FORM));
  submitted: boolean = false;
  submitSuccess: boolean = false;

  resetForm() {
    this.jobappform = JSON.parse(JSON.stringify(DEFAULT_JOBAPP_FORM));
  }
  public submitForm() {
    (this as any).$refs.observer.validate().then((valid: any) => {
      const data = JSON.parse(JSON.stringify(this.jobappform));
      data.job = this.pageData.id;
      var formData = new FormData();
      const files = (this as any).$refs.cv.files;
      if (files.length) {
        formData.append("cv", files[0]);
        Object.keys(data).map((key: string) => {
          formData.append(key, data[key]);
        });
        axios
          .post(`${API_URL}/job-application-form/`, formData)
          .then((resp: any) => {
            this.submitted = true;
            console.log(resp);
            this.submitSuccess = true;
          })
          .catch((err: any) => {
            this.submitted = true;
            console.log(err);
          });
      }
    });
  }
  public heroimganim() {
    var heroimganim = new TimelineMax({});
    heroimganim
      .from(".banner-wrap", 1.3, {
        y: "100%",
        ease: Expo.easeInOut,
        clearProps: "all",
      })
      .from(".banner-wrap img", 0.7, {
        y: 0,
        scale: 1.2,
        ease: Power2.easeInOut,
        clearProps: "all",
      })
      .staggerFrom(
        ".banner-text",
        0.8,
        {
          autoAlpha: 0,
          height: 0,
          ease: Expo.easeInOut,
          clearProps: "all",
        },
        0.01,
        "-=.3"
      )
      .staggerFrom(
        ".banner-text h1",
        0.8,
        {
          autoAlpha: 0,
          y: 80,
          ease: Expo.easeOut,
          clearProps: "all",
        },
        0.1,
        "-=.5"
      )
      .staggerFrom(
        ".banner-text p",
        0.8,
        {
          autoAlpha: 0,
          y: 80,
          ease: Expo.easeOut,
          clearProps: "all",
        },
        0.1,
        "-=.6"
      );
  }
  public mounted() {
    this.heroimganim();
  }
}
